import React, { useState, useEffect, useRef, useMemo } from "react"; // Import React and useState
import { useNavigate, useParams, Link } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import Frontid from "../assets/images/front-id.svg";
import Backid from "../assets/images/back-id.svg";
import Selfieid from "../assets/images/selfie-id.png";
import checkIcon from "../assets/images/check-circle.svg";
// import checkIcon from "../assets/images/done.svg";
import uncheckIcon from "../assets/images/undone.svg";
import deleteImage from "../assets/images/delete.svg";
import { useSelector, useDispatch } from "react-redux";
import { onboardingActions } from "./../store/onboarding.slice";
import { paymentActions } from "./../store/payment.slice";
import HttpStatus from "./../helpers/status.enum";
import SpinnerLoader from "../components/SpinnerLoader";
import { commonActions } from "../store/common.slice";
import { checkInActions } from "../store/checkin.slice";
import { commonRenderTextWithLinks } from "../config/functions";
import heic2any from "heic2any";
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// import required modules
import { Pagination, Navigation } from "swiper/modules";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { toast } from "react-toastify";
import CryptoJS from "crypto-js"; // For decrypt the stripe key

// Modalbox

import Modal from "react-bootstrap/Modal";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "../components/CheckoutForm";
import UpgradeItems from "../components/UpgradeItems";
import { PhoneInput, defaultCountries, parseCountry } from 'react-international-phone';
import { createVeriffFrame, MESSAGES } from "@veriff/incontext-sdk";

// Override Argentina's mask to support mobile numbers (+54 9 11 XXXX XXXX = 11 digits after dial code)
const customCountries = defaultCountries.map((country) => {
  const parsed = parseCountry(country);
  if (parsed.iso2 === 'ar') {
    // Raw tuple: [name, iso2, dialCode, mask, priority, areaCodes]
    // Replace mask at index 3 — add one extra dot for the mobile "9" prefix
    return [parsed.name, parsed.iso2, parsed.dialCode, '. (..) ........', parsed.priority ?? 0];
  }
  return country;
});


let stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
const encryKey = process.env.REACT_APP_STRIPE_ENCRYPT_KEY; // Must be 16 bytes for AES-128
const REACT_APP_API_URL = process.env.REACT_APP_API_URL || "";

function Checkingin({
  checkedInPageHandle,
  checkingPageHandle,
  reservationPageHandle,
}) {
  // Modalbox

  const dispatch = useDispatch();

  const navigate = useNavigate();

  // Getting confirmation Code from redux
  const bookingSlug = useSelector((data) => {
    return data.checkIn.bookingSlug;
  });
  const listingSlug = useSelector(state => state.checkIn.listingSlug);

  const startTime = 120; // 2 minutes in seconds
  const chargeOtpText = localStorage.getItem('charge-otp-text');

  const [showCreditCardModal, setShowCreditCardModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedPaymentOption, setSelectedPaymentOption] = useState("nonrefundable");
  const [clientSecret, setClientSecret] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [stripeId, setStripeId] = useState(null);
  const [paymentSlug, setPaymentSlug] = useState(null);
  const [intentType, setintentType] = useState(0);
  const [loader, setLoader] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [cmsContent, setCmsContent] = useState(null);
  const [listingCms, setListingCms] = useState(null);
  const [houseRules, setHouseRules] = useState([]);
  const [houseRuleCount, setHouseRuleCount] = useState(null);
  const [securityDepositAlert, setSecurityDepositAlert] = useState([]);
  const [swiperVerifyRef, setVerifySwiperRef] = useState(null);
  const [isSignedButtonDisabled, setIsSignedButtonDisabled] = useState(true);

  const [reservationType, setReservationType] = useState(null);
  const [isSigning, setIsSigning] = useState(false);  // button signed spinner state
  const [showConsentModal, setShowConsentModal] = useState(false);
  const [onBoardingApiFail, setOnBoardingApiFail] = useState(false);
  const [itemsList, setItemsList] = useState([]);
  const [isFormSubmittedProtection, setIsFormSubmittedProtection] = useState(false);
  // type name and enable button

  const [name, setName] = useState("");
  const [isNameValid, setIsNameValid] = useState(false);

  // const [selectedDocs, setSelectedDocs] = useState([]);
  const [responses, setResponses] = useState([]);
  const [buttonClicked, setButtonClicked] = useState(false);
  // Select checkbox

  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [buttonText, setButtonText] = useState("I Agree"); // State to manage button text
  const [verifybuttonText, setverifyButtonText] = useState(
    <div>
      Add photo of front of <span className="text-uppercase">ID</span>
    </div>
  ); // State to manage button text
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false); // State to manage checkbox checked state
  const [isCheckboxCheckedSign, setIsCheckboxCheckedSign] = useState(false); // State to manage checkbox checked state for esign
  const [checkedCount, setCheckedCount] = useState(0); // State to track the number of checked checkboxes
  const [isFormSubmittedhouserules, setIsFormSubmittedhouserules] = useState(false);
  // Sign on the dotted line
  const [showAgreementModalagree, setShowAgreementModalboxagree] = useState(false);

  const [isFormSubmittedagree, setIsFormSubmittedagree] = useState(false);
  // Verifyed it's you upload ID

  const [selectedFrontImage, setSelectedFrontImage] = useState(null);
  const [selectedBackImage, setSelectedBackImage] = useState(null);

  const [showIdCardModal_Front, setshowIdCardModal_Front] = useState(false);
  const [showIdCardModal_Back, setshowIdCardModal_Back] = useState(false);
  const [showIdCardModal_Selfie, setshowIdCardModal_Selfie] = useState(false);

  const [selectedSelfieImage, setSelectedSelfieImage] = useState(null);
  const [isFormSubmittedverify, setIsFormSubmittedverify] = useState(false);
  // Accrodian
  const [activeAccordionKey, setActiveAccordionKey] = useState(null); // bydefault no accordian should open
  // Swiper slider
  const [swiperRef, setSwiperRef] = useState(null);
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [checkboxSMSEarlyCheckin, setCheckboxSMSEarlyCheckin] = useState(false);
  const [authCode, setAuthCode] = useState(null);
  const [userInputOtp, setUserInputOtp] = useState(null);
  const [showotpModal, setotpModal] = useState(false);
  const [timer, setTimer] = useState(0);
  const [otpInputs, setOtpInputs] = useState(["", "", "", "", "", ""]);
  const [isFormValidOTP, setIsFormValidOTP] = useState(false);
  const inputRefs = useRef([]); // Ref for each OTP input field
  const [isOtpVerified,setIsOtpVerified] = useState(false); // 0 means not verified
  const [isGuestAllowedToPay, setIsGuestAllowedToPay] = useState(true);
  const [isHoldOnlyWaiver, setisHoldOnlyWaiver] = useState(false);
  // Controls whether the Veriff identity verification flow is active for the guest
  const [isVeriffVerificationEnable, setIsVeriffVerificationEnable] = useState(false);
  // Triggers the SSE Event
  const [idVerificationStarted, setIdVerificationStarted] = useState(false);
  const idVerificationStartedRef = useRef(false);
  const eventSourceRef = useRef(null);
  const reconnectTimerRef = useRef(null);
  // Disable Button of Guest ID during Veriff / Sex offender flow
  const [isGuestBlocked, setIsGuestBlocked] = useState(false);
  // URL to load Veriff iframe
  const [sessionUrl, setSessionUrl] = useState(""); 
  const veriffRef = useRef(null);
  // Manage Veriff Verification Timeout from Webhook (SSE)
  const [isGuestIDTimeout, setGuestIDTimeout] = useState(false);

  // Container ID for embedding Veriff iframe
  const embeddedContainerId = useMemo(() => "veriff-embedded-container", []);

  const [openForm, setOpenForm] = useState(null);
  const [isAdditionalFormRequired, setIsAdditionalFormRequired] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAdditionalFormCompleted, setIsAdditionalFormCompleted] = useState(true);
  const [isBookingLoaded, setIsBookingLoaded] = useState(false); // true; after booking api finished execution
  const [isOnboardingLoaded, setIsOnboardingLoaded] = useState(false); // true; after onboarding api finished execution
  const iframeRef = useRef(null);
  const options = {
    clientSecret: clientSecret,
    appearance: {
      /*...*/
    },
  };
  const activeKeyStep = {
    HOUSE_RULE: 0,
    RENTAL_AGREEMENT: 1,
    GUEST_ID_VERIFICATION: 2,
    PAYMENT_CARD: 3,
    GUEST_UPGRADES: 4,
  }

  // Scrooll Top start
  // Function to scroll to the top of the page

  // const scrollToTop = () => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth",
  //   });
  // };

  // Scroll to top when component mounts or navigates
  useEffect(() => {
    // Find the position of the "Checking In" section relative to the top of the document
    const checkingInSection = document.getElementById("checkingIn");
    const sectionPosition = checkingInSection.getBoundingClientRect().top;

    // Scroll the page to the position of the "Checking In" section
    window.scrollTo({
      top: sectionPosition,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    const fetchBookingData = async () => {
      try {
        const bookingResult = await dispatch(
          checkInActions.getBookingByCode(bookingSlug)
        );
        if (bookingResult?.payload?.status === HttpStatus.HTTP_OK) {
          const { is_verification_allow = false, is_guest_sex_offended = false } = bookingResult?.payload?.result || {};
          setReservationType(bookingResult?.payload?.result?.is_airbnb_booking);
          const paymentCardEnable = bookingResult?.payload?.result?.is_guest_allowed_to_pay;
          setIsGuestAllowedToPay(paymentCardEnable); // Card Hide / Display Logic
          // Hold Only Option used when host select hold only waiver option
          const holdOnlyWaiver = bookingResult.payload?.result?.is_hold_only_waiver;
          setisHoldOnlyWaiver(holdOnlyWaiver);
          // If Hold Only is true, hide the non-refundable option and automatically select the refundable option for the guest.
          if(holdOnlyWaiver) {
            setSelectedPaymentOption("refundable");
          }
          if (bookingResult?.payload?.result?.is_guest_form_bypass === 1) {
            reservationPageHandle(true);
            checkingPageHandle(false);
            checkedInPageHandle(false);
            // navigate("/reservationinfo");
          }
          setSecurityDepositAlert(
            bookingResult?.payload?.result?.security_deposit
          );
          setListingCms(bookingResult?.payload?.result?.listing);
          const houseRulesJson =
            bookingResult?.payload?.result?.listing?.house_rules;
          var houseRules = JSON.parse(houseRulesJson);
          houseRules = houseRules.map(function (rule) {
            return {
              id: rule.id,
              label: rule.label,
            };
          });
          setHouseRules(houseRules);
          setHouseRuleCount(
            bookingResult?.payload?.result?.listing?.total_house_rules
          );
          if(bookingResult?.payload?.result?.is_otp_verified == 1){
            setIsOtpVerified(true); 
            setIsFormValid(true); // don't disable the signed button on signned accordian if otp already verified found.
          }
          // If veriff verification flow enable then Change the button text and update state
          if(is_verification_allow){
            setIsVeriffVerificationEnable(is_verification_allow)
            if(is_guest_sex_offended) {
              setIsGuestBlocked(true); // Disable button and not allow to submit for ID verification.
              setverifyButtonText(
                <div>
                  Pending <span className="text-uppercase">A</span>pproval
                </div>
              );
            } else {
              setverifyButtonText(
                <div>
                  Start <span className="text-uppercase">V</span>erification
                </div>
              );
            }
          }
          const isFormRequiredFromBooking = bookingResult.payload?.result?.listing.form_required_by_guest;
          const formUrl = bookingResult.payload?.result?.listing.form_url
          if(isFormRequiredFromBooking && formUrl) {
            setIsAdditionalFormCompleted(false);
            setIsAdditionalFormRequired(true);
            setOpenForm(formUrl)
          }
          setIsBookingLoaded(true);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchBookingData();
  }, []);

  useEffect(() => {
    const getOnboardingStep = async () => {
      setIsLoading(true);

      try {
        const { payload } = await dispatch(onboardingActions.getOnboardingStep(bookingSlug));

        if (!payload) return;

        const {
          isCheckinCompleted,
          isHouseRulesAccepted,
          signedOnDottedLine,
          isVerificationIdsUploaded,
          isDepositOption,
          isGuestSexOffended,
        } = payload;

        if (isCheckinCompleted) {
          reservationPageHandle(true);
          checkingPageHandle(false);
          checkedInPageHandle(false);
        }

        setIsFormSubmittedhouserules(isHouseRulesAccepted === 1);
        setIsFormSubmittedagree(signedOnDottedLine === 1);

        // Fix: use payload instead of stale state
        setIsFormSubmittedverify(isVerificationIdsUploaded === 1 && isGuestSexOffended !== 1);

        setIsFormSubmittedProtection(isDepositOption === 1);

        const { payload: cmsPayload } = await dispatch(
          commonActions.getCmsContents()
        );

        if (cmsPayload?.status === HttpStatus.HTTP_OK) {
          const cmsData = cmsPayload.result;
          setCmsContent(cmsData);
        }
        setIsOnboardingLoaded(true);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    getOnboardingStep();
  }, []);

  // Configure logic of which accordian should active at different useCase 
  // (i.e. Airbnb/Vrbo, Automatic Payment, House Rules Hide/Show, Rental Agreement Hide/Show)
  useEffect(() => {
    if (!isBookingLoaded || !isOnboardingLoaded) return;
    
    const houseRulesStepClear = isFormSubmittedhouserules;
    const rentalAgreementStepClear = isFormSubmittedagree;
    const idVerificationStepClear  = (isFormSubmittedverify || reservationType === 1);
    
    let localActiveAccordionKey = activeKeyStep.HOUSE_RULE; // Default: House Rule
    // Step 1: House rules Completed
    if (houseRulesStepClear) {
      // Step 2: Rental Agreement Clear then
      localActiveAccordionKey = activeKeyStep.RENTAL_AGREEMENT; // Opens Rental Agreement Popup As Housel Rules Accepted.
      if(rentalAgreementStepClear) {
        localActiveAccordionKey = activeKeyStep.GUEST_ID_VERIFICATION; // Opens Guest ID verification If flow is not Airbnb.
        if (idVerificationStepClear) { // Airbnb/Vrbo flow where Guest ID verification we not ask.
          if (isGuestAllowedToPay) { // false when waiver option not Automatic configured for host
            localActiveAccordionKey = activeKeyStep.PAYMENT_CARD; // Opens Payment Popup If waiver option is not Automatic.
            // Step 4: Protection Completed
            if (isFormSubmittedProtection) {
              localActiveAccordionKey = activeKeyStep.GUEST_UPGRADES; // Opens Guest Upgrades Popup
              fetchUpsellsItem();
            }
          } else {
            localActiveAccordionKey = activeKeyStep.GUEST_UPGRADES; // Opens Guest Upgrades Popup If flow is Automatic.
            fetchUpsellsItem();
          }
        }
      }
    }
    setActiveAccordionKey(localActiveAccordionKey.toString());
  }, [
    isBookingLoaded, // true when bookingInfo api completed
    isOnboardingLoaded, // true when onboarding api completed
    isFormSubmittedhouserules, // house rules step hook
    isFormSubmittedagree, // rental agreement step hook
    reservationType, // 1 means airbnb no id verification required
    isGuestAllowedToPay, // true if Guest allow to do payment 
    isFormSubmittedverify, // guest id verification step hook
    isFormSubmittedProtection, // payment step hook
  ]);

  useEffect(() => {
    let container = "";
    if(isOtpVerified){
      container = document.querySelector(".checkBox-text-heading")
    } else {
      container = document.querySelectorAll(".checkBox-text-heading")[1];
    }
    const handleClick = (event) => {
      if (event.target && event.target.matches(".checkBox-text-heading-link")) {
        setShowConsentModal(true);
      }
    };
    if (container) {
      container.addEventListener("click", handleClick);
    }
    return () => {
      if (container) {
        container.removeEventListener("click", handleClick);
      }
    };
  }, [showAgreementModalagree]);

  useEffect(() => {
    if (buttonClicked) {
      reservationPageHandle(true);
      checkingPageHandle(false);
      checkedInPageHandle(false);
    }
  }, [buttonClicked, navigate]);

  useEffect(() => {
    if (responses.length === 3) {
      const formData = {
        is_house_rules_accepted: 0,
        is_signed_on_dotted_line: 0,
        is_verification_ids_uploaded: 1,
        is_deposit_option: 0,
        verification_images: responses,
        is_arrival_info_accepted: 0,
        form_submission_at: 0,
      };
      submitOnboardingSteps(formData);
      // setIsFormSubmittedverify(true); // Set the form submission state to true
    }
  }, [responses]);

  // Scroll to top when component mounts or navigates
  useEffect(() => {
      scrollToTop();
      if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
      }
  }, []);

  useEffect(() => {
    let interval;
    if (showotpModal && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);  // Decrease by 1 second
      }, 1000);
    } else {
      clearInterval(interval);  // Stop the timer if timer reach 0
    }

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [showotpModal, timer]);

  useEffect(() => {
    idVerificationStartedRef.current = idVerificationStarted;
  }, [idVerificationStarted]);

  // Effect to embed the Veriff iframe once the session URL is available
  useEffect(() => {
    // Session URL, embedded not have then prevent to open veriff iframe.
    if (!sessionUrl || !embeddedContainerId || !isVeriffVerificationEnable) {
      return;
    }
    // // close the iframe previously it open (Fresh iframe load)
    // veriffRef.current?.close();

    // Create Veriff iframe with necessary options
    const frame = createVeriffFrame({
      url: sessionUrl,
      embedded: true,
      embeddedOptions: {
        rootElementID: embeddedContainerId, // ID where iframe will be rendered
      },
      onEvent: async (message) => {
        switch (message) {
          case MESSAGES.STARTED:
            break;
          case MESSAGES.SUBMITTED: // Thank you button visible at a moment this event raised
            idVerificationStartedRef.current = true;
            setIdVerificationStarted(true); // Start SSE After form submitted by guest
            break;
          case MESSAGES.FINISHED: // Closes the Thank you button by tapping continue
            // SSE is started only from SUBMITTED event.
            closeVeriffModal(); // Close iframe once user taps continue on Veriff
            break;
          case MESSAGES.CANCELED:
            // If after submitted cancel event occured it that case we still have to alive SSE connection.
            if (idVerificationStartedRef.current) {
              // If already submitted, keep SSE alive and only close the iframe.
              closeVeriffModal();
            } else {
              resetSession();
            }
            break;
          case MESSAGES.RELOAD_REQUEST:
            break;
          default:
            break;
        }
      },
    });
    veriffRef.current = frame;
  }, [embeddedContainerId, sessionUrl]);

  // SSE (Server side event) After Guest ID Submitted/Finished.
  useEffect(() => {
    if (!bookingSlug || !idVerificationStarted) return;

    const connect = () => {
      if (
        eventSourceRef.current &&
        eventSourceRef.current.readyState !== EventSource.CLOSED
      ) {
        return; // Prevent duplicate connections
      }

      const es = new EventSource(
        `${REACT_APP_API_URL}/checkin/veriff-stream-status/${bookingSlug}`,
      );

      eventSourceRef.current = es;

      es.onopen = () => {
        clearTimeout(reconnectTimerRef.current);
        reconnectTimerRef.current = null;
      };

      const handleTerminalEvent = (event) => {
        try {
          const data = JSON.parse(event.data);
          const { status, message, is_blocked, is_decline, timeout } = data;
          let formFinished = false;

          if (status) {
            handleVeriffFinished(); // move to next step.
            formFinished = true;
          } else {
            // Guest blocked here for have to disable the button
            if(is_blocked) {
              setverifyButtonText(
                <div>
                  Pending <span className="text-uppercase">A</span>pproval
                </div>
              );
              setIsGuestBlocked(true);
            } else {
              toast(message); // show error toast
            }
            if([is_decline,timeout].some(Boolean)) {
              setverifyButtonText(
                <div>
                  Try <span className="text-uppercase">A</span>gain
                </div>
              );
            }
            if(timeout) {
              // After timeout if user tap on Try Again Button it will hard-reload the browser.
              setGuestIDTimeout(true);
            }
          }

          resetSession(formFinished); // close iframe + stop SSE on any terminal response
        } catch (err) {
          console.error("Invalid SSE data:", err);
        }
      };

      es.addEventListener("SUCCESS", handleTerminalEvent);
      es.addEventListener("TIMEOUT", handleTerminalEvent);
      es.addEventListener("NOT_FOUND", handleTerminalEvent);
      es.addEventListener("ERROR", handleTerminalEvent);
      es.addEventListener("DECLINED", handleTerminalEvent);

      es.onerror = () => {
        // Reconnect only for transport/network errors.
        if (!idVerificationStarted) return;
        if (eventSourceRef.current) {
          eventSourceRef.current.close();
          eventSourceRef.current = null;
        }
        clearTimeout(reconnectTimerRef.current);
        reconnectTimerRef.current = setTimeout(() => {
          connect();
        }, 3000);
      };
    };

    connect();

    return () => {
      stopSse();
    };
  }, [bookingSlug, idVerificationStarted]);

  const handleCreditCardModalOpen = async () => {
    setLoader(true);
    let intentType = 0;
    if (selectedPaymentOption === "nonrefundable") {
      intentType = 1;
    } else if (selectedPaymentOption === "refundable") {
      intentType = 2;
    }
    setintentType(intentType);
    const formData = {
      booking_slug: bookingSlug,
      intent_type: intentType,
    };
    if(reservationType === 1 && selectedPaymentOption === "refundable") {
      
      const formData = {
        is_house_rules_accepted: 0,
        is_signed_on_dotted_line: 0,
        is_verification_ids_uploaded: 0,

        is_deposit_option: 1,
        deposit_option: intentType,
        card_token: "Not Applicable",
        is_arrival_info_accepted: 0,
        form_submission_at: 0,
      };
      submitOnboardingSteps(formData);
    } else {
      const result = await dispatch(paymentActions.createPaymentIntent(formData));
      const responses = result?.payload;
      if (responses?.status === HttpStatus.HTTP_OK) {
        const paymentRes = responses.result;
        setClientSecret(paymentRes?.client_secret);
        setCustomerId(paymentRes?.customer_id);
        setStripeId(paymentRes?.id);
        setPaymentSlug(paymentRes?.payment_slug);
        setShowCreditCardModal(true);
        setLoader(false);
        if (paymentRes?.host_account_id) {
          // On e-commerece payment need to pass stripe publishkey based on connected id
          const encryptedData = paymentRes?.host_account_id; // Replace with your base64-encoded encrypted data
  
          const decryptedData = decryptData(encryptedData, encryKey);
          stripePromise = loadStripe(
            process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
            { stripeAccount: decryptedData }
          );
        }else{
          stripePromise = loadStripe(
            process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
          );
        }
      } else {
        toast(responses?.message);
        setLoader(false);
      }
    }
  };

  function decryptData(encryptedData, key) {
    // Decrypt the data
    const bytes = CryptoJS.AES.decrypt(
      encryptedData,
      CryptoJS.enc.Utf8.parse(key),
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    // Convert decrypted bytes to a UTF-8 string
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

    return decryptedData;
  }

  // Function to handle radio button payment option change
  const handlePaymentOptionChange = (event) => {
    setSelectedPaymentOption(event.target.value);
  };

  // Callback function to receive data from child component
  const closeCheckoutModal = (data) => {
    setShowCreditCardModal(false);
    setLoader(false);
  };

  // Callback function to receive data from child component
  const gotoHomePage = async () => {
    setLoader(true);
    try {
      const formData = {
        is_house_rules_accepted: 0,
        is_signed_on_dotted_line: 0,
        is_verification_ids_uploaded: 0,
        is_deposit_option: 0,
        is_arrival_info_accepted: 1,
        form_submission_at: 0,
      };
      await submitOnboardingSteps(formData);
    } catch (error) {
      console.error("Error fetching data :", error);
    } finally {
      setLoader(false)
    }
  };

  const nextUpsellCardStep = () => {
    setShowCreditCardModal(false);
    setIsFormSubmittedProtection(true);
    setLoader(false);
  };

  const handleNameChange = (event) => {
    const inputValue = event.target.value;
    setName(inputValue);
    setIsNameValid(inputValue.trim().length > 0);
    setIsSignedButtonDisabled(!isCheckboxCheckedSign || !inputValue.trim());
  };

  // const handleSubmit = (event) => {
  //   event.preventDefault();
  // };

  // Read the house rules card

  /*const checkboxes = [
    {
      id: "nosmoking",
      label: "There is no smoking inside the premises."
    },
    {
      id: "noparties",
      label: "There are no parties or events at the premises."
    },
    {
      id: "nooutsideguests",
      // label: "No outside guests (only guests on reservation)",
      label: "Respect neighbors. Quiet Hours are 10pm - 7am.",
    }
  ];*/
  const checkboxes = houseRules;
  const handleAgreeButtonClick = () => {
    if(onBoardingApiFail) {
      const formData = {
        is_house_rules_accepted: 1,
        is_signed_on_dotted_line: 0,
        is_verification_ids_uploaded: 0,
        is_deposit_option: 0,
        is_arrival_info_accepted: 0,
        form_submission_at: 0,
      };
      submitOnboardingSteps(formData);
      return ;
    }
    const checkboxId = checkboxes[currentIndex].id;
    // Toggle the selection of the current checkbox
    setSelectedCheckboxes((prevSelectedCheckboxes) => {
      if (prevSelectedCheckboxes.includes(checkboxId)) {
        return prevSelectedCheckboxes.filter((id) => id !== checkboxId); // Deselect the checkbox
      } else {
        return [...prevSelectedCheckboxes, checkboxId]; // Select the checkbox
      }
    });

    swiperRef.slideNext(); // Move to the next slide
    setCurrentIndex((prevIndex) => (prevIndex + 1) % checkboxes.length); // Wrap around the index
    setIsCheckboxChecked((prevState) => !prevState);

    if (selectedCheckboxes.length === houseRuleCount) {
      const formData = {
        is_house_rules_accepted: 1,
        is_signed_on_dotted_line: 0,
        is_verification_ids_uploaded: 0,
        is_deposit_option: 0,
        is_arrival_info_accepted: 0,
        form_submission_at: 0,
      };
      submitOnboardingSteps(formData);
    }
    // Increment checkedCount when checkbox is checked
    if (!selectedCheckboxes.includes(checkboxId)) {
      setCheckedCount((prevCount) => prevCount + 1);
    }

    // Update button text dynamically based on checkbox status
    const buttonText = selectedCheckboxes.includes(checkboxId)
      ? "I Agreed"
      : "I Agree";
    setButtonText(buttonText);

    if (selectedCheckboxes.length >= houseRuleCount) {
      setButtonText("I Agreed");
      setIsButtonDisabled(true);
      // setIsFormSubmittedhouserules(true);
    } else {
      setButtonText("I Agree");
      setIsButtonDisabled(false);
      // setIsFormSubmittedhouserules(false);
    }
  };

  const handleSubmithouserules = (event) => {
    event.preventDefault();
    // Here you can perform any submission logic
    //setIsFormSubmittedhouserules(true); // Set the form submission state to true
  };

  // Function to handle swiper slide change
  const handleSlideChange = () => {
    let checkboxId;
    if (currentIndex > 0) {
      checkboxId = checkboxes[currentIndex - 1].id;
    } else {
      checkboxId = checkboxes[currentIndex].id;
    }

    const buttonText = selectedCheckboxes.includes(checkboxId) ? "I agreed" : "I agree";
    setButtonText(buttonText);
    setIsButtonDisabled(true);
  };

  // Function to handle swiper slide next
  const handleSlideNext = () => {
    const checkboxId = checkboxes[currentIndex].id;
    const buttonText = selectedCheckboxes.includes(checkboxId)
      ? "I agreed"
      : "I agree";
    setButtonText(buttonText);
    // setIsButtonDisabled(true);
  };

  // Function to handle swiper slide prev
  const handleSlidePrev = () => {
    const checkboxId = checkboxes[currentIndex].id;
    const buttonText = selectedCheckboxes.includes(checkboxId) ? "I agreed" : "I agree";
    setButtonText(buttonText);
    setIsButtonDisabled(true);
  };
  
  const handleAgreementModalOpen = () => {
    setShowAgreementModalboxagree(true);
  };

  const handleSubmitagree = async (event) => {
    // Here you can perform any submission logic
    // setIsFormSubmittedagree(true); // Set the form submission state to true
    event?.preventDefault();
    setIsLoading(true);
    
    if (name !== "") {
      const formData = {
        is_house_rules_accepted: 0,
        is_signed_on_dotted_line: 1,
        is_verification_ids_uploaded: 0,
        is_deposit_option: 0,

        signed_name: name,
        is_arrival_info_accepted: 0,
        form_submission_at: 0,
      };
      await submitOnboardingSteps(formData);   // submit the form data
    }
    setIsLoading(false);
  };

  const handleDeleteFrontImage = () => {
    setSelectedFrontImage(null); // Set the front image to null to delete it
  };
  const handleDeleteBackImage = () => {
    setSelectedBackImage(null); // Set the front image to null to delete it
  };
  const handleDeleteSelfieImage = () => {
    setSelectedSelfieImage(null); // Set the front image to null to delete it
  };

  const handleFrontButtonClick = () => {
    document.getElementById("front_id_card").click();
  };

  const handleBackButtonClick = () => {
    document.getElementById("back_id_card").click();
  };

  const handleSelfieButtonClick = (camera = true) => {
    if (camera) {
      document.getElementById("selfie_id").click();
    } else {
      document.getElementById("selfie_id_card").click();
    }
  };

  const handleFrontImageChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      let imageBlob = file;
      const isHeic = file.type === "image/heic" || file.name.toLowerCase().endsWith(".heic");
      // Convert HEIC to JPEG
      if (isHeic) {
        setIsDisabled(true);
        imageBlob = await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.9,
        });
      }
      const reader = new FileReader();
      reader.onload = () => {
        compressImage(reader.result, (compressedImage) => {
          setSelectedFrontImage(compressedImage);
          if (compressedImage) {
            uploadOnboardingMedia(compressedImage, "front_image");
          }
          /*if (swiperVerifyRef) {
            swiperVerifyRef.slideNext(); // Move to the next slide
          }*/
        });
      };
      reader.readAsDataURL(imageBlob);
    }
  };

  const compressImage = (imageData, callback) => {
    const img = new Image();
    img.src = imageData;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // Set the canvas dimensions to the resized image dimensions
      const maxWidth = 800; // Adjust as needed
      const maxHeight = 600; // Adjust as needed
      let width = img.width;
      let height = img.height;

      if (width > maxWidth || height > maxHeight) {
        const aspectRatio = width / height;
        if (width > height) {
          width = maxWidth;
          height = width / aspectRatio;
        } else {
          height = maxHeight;
          width = height * aspectRatio;
        }
      }

      canvas.width = width;
      canvas.height = height;

      // Draw image onto canvas
      ctx.drawImage(img, 0, 0, width, height);

      // Get the compressed image data
      const compressedImageData = canvas.toDataURL("image/jpeg", 1); // Adjust quality (0.7 is just an example)

      callback(compressedImageData);
    };
  };

  const handleBackImageChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      let imageBlob = file;
      const isHeic = file.type === "image/heic" || file.name.toLowerCase().endsWith(".heic");
      // Convert HEIC to JPEG
      if (isHeic) {
        setIsDisabled(true);
        imageBlob = await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.9,
        });
      }
      const reader = new FileReader();
      reader.onload = () => {
        compressImage(reader.result, (compressedImage) => {
          setSelectedBackImage(compressedImage);
          if (compressedImage) {
            uploadOnboardingMedia(compressedImage, "back_image");
          }
          /*if (swiperVerifyRef) {
            swiperVerifyRef.slideNext(); // Move to the next slide
          }*/
        });
      };
      reader.readAsDataURL(imageBlob);
    }
  };

  const handleSelfieImageChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      let imageBlob = file;
      const isHeic = file.type === "image/heic" || file.name.toLowerCase().endsWith(".heic");
      // Convert HEIC to JPEG
      if (isHeic) {
        setIsDisabled(true);
        imageBlob = await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.9,
        });
      }
      const reader = new FileReader();
      reader.onload = () => {
        compressImage(reader.result, (compressedImage) => {
          setSelectedSelfieImage(compressedImage);
          if (compressedImage) {
            uploadOnboardingMedia(compressedImage, "selfie_image");
          }
          /*if (swiperVerifyRef) {
            swiperVerifyRef.slideNext(); // Move to the next slide
          }*/
        });
      };
      reader.readAsDataURL(imageBlob);
    }
  };

  const uploadOnboardingMedia = async (imageBase64Data, eventType) => {
    setIsDisabled(true);
    const formData = {
      file: imageBase64Data,
      listing_slug: listingSlug,
    };
    try {
      const result = await dispatch(onboardingActions.uploadMedia(formData));
      if (result?.payload?.status === HttpStatus.HTTP_OK) {
        const response = result?.payload?.result;
        // Check if an entry with the same eventType exists
        const existingIndex = responses.findIndex(
          (entry) => Object.keys(entry)[0] === eventType
        );

        if (existingIndex !== -1) {
          // Update the existing entry
          setResponses((prevResponses) => {
            const updatedResponses = [...prevResponses];
            updatedResponses[existingIndex] = {
              [eventType]: response.fileName,
            };
            return updatedResponses;
          });
        } else {
          // Add new entry to responses
          setResponses((prevResponses) => [
            ...prevResponses,
            { [eventType]: response.fileName },
          ]);
        }
        if (swiperVerifyRef) {
          swiperVerifyRef.slideNext(); // Move to the next slide
        }
      } else {
        if (eventType === "front_image") {
          setSelectedFrontImage(null);
        }
        if (eventType === "back_image") {
          setSelectedBackImage(null);
        }
        if (eventType === "selfie_image") {
          setSelectedSelfieImage(null);
        }
      }
    } catch (error) {
      console.error("Error occurred while submitting form:", error);
    } finally {
      if(eventType !== "selfie_image"){
        setIsDisabled(false);
      }
    }
  };

  const handleIdCardModalOpen = () => {
    // If Veriff verification is enabled, manual image upload is not allowed.
    if(isVeriffVerificationEnable) {
      if(isGuestIDTimeout){
        // Timeout path: hard refresh before retrying verification.
        hardRefreshAfterVeriffTimeout();
      } else {
        handleVerificationGuestID(); // Retrieve the sessionUrl
      }
    } else {
      if (selectedFrontImage && selectedBackImage && selectedSelfieImage) {
        if (onBoardingApiFail) {
          const formData = {
            is_house_rules_accepted: 0,
            is_signed_on_dotted_line: 0,
            is_verification_ids_uploaded: 1,
            is_deposit_option: 0,
            verification_images: responses,
            is_arrival_info_accepted: 0,
            form_submission_at: 0
          };
          submitOnboardingSteps(formData);
        }
        // setIsFormSubmittedverify(true);
      } else if (selectedFrontImage == null) {
        setshowIdCardModal_Front(true);
        setverifyButtonText(
          <div>
            Add photo of front of <span className="text-uppercase">ID</span>
          </div>
        );
      } else if (selectedBackImage == null) {
        setshowIdCardModal_Back(true);
        setverifyButtonText(
          <div>
            Add photo of back of <span className="text-uppercase">ID</span>
          </div>
        );
      } else if (selectedSelfieImage == null) {
        setshowIdCardModal_Selfie(true);
        setverifyButtonText(
          <div>
            Add selfie holding <span className="text-uppercase">ID</span>
          </div>
        );
      }
    }
  };

  const handleSubmitverify = (event) => {
    event.preventDefault();
  };

  const handleVerifySlideChange = () => {
    // Determine which slide is active and set button text accordingly
    switch (swiperVerifyRef.activeIndex) {
      case 0:
        setverifyButtonText(
          <div>
            Add photo of front of <span className="text-uppercase">ID</span>
          </div>
        );
        break;
      case 1:
        setverifyButtonText(
          <div>
            Add photo of back of <span className="text-uppercase">ID</span>
          </div>
        );
        break;
      case 2:
        setverifyButtonText(
          <div>
            Add selfie holding <span className="text-uppercase">ID</span>
          </div>
        );
        break;
      default:
        setverifyButtonText(""); // Reset button text if none of the cases match
    }
  };

  // Body in add class for overlay remove

  const handleClick = () => {
    // Add your class to the body tag
    document.body.classList.add("signOndotted");
  };

  const submitOnboardingSteps = async (requestData) => {
    const formData = {
      booking_slug: bookingSlug,
      ...requestData,
    };
    try {
      const result = await dispatch(
        onboardingActions.submitOnboardingSteps(formData)
      );
      if (result?.payload?.status === HttpStatus.HTTP_OK) {
        setOnBoardingApiFail(false);
        checkingPageHandle(true);
        checkedInPageHandle(false);
        if (requestData.is_house_rules_accepted === 1) {
          setIsFormSubmittedhouserules(true);
        }
        if (requestData.is_signed_on_dotted_line === 1) {
          setIsFormSubmittedagree(true);
        }
        if (requestData.is_verification_ids_uploaded === 1) {
          setIsFormSubmittedverify(true);
          setIsDisabled(false);
        }
        if (requestData.is_deposit_option === 1) {
          setIsFormSubmittedProtection(true);
          setLoader(false);
        }
        if(requestData.is_arrival_info_accepted === 1) {
          setButtonClicked(true); // After successful data update redirect to reservationInfo page
        }
        // navigate("/checkingin");
      } else {
        if(requestData.is_arrival_info_accepted === 1){ // If payment required and not done before scene message
          toast(result?.payload?.message);
        }
        // Handle other cases if needed
        setOnBoardingApiFail(true);
        if (requestData.is_house_rules_accepted === 1) {
          setIsButtonDisabled(false);
        }
        if (requestData.is_verification_ids_uploaded === 1) {
          setverifyButtonText(<div>Proceed</div>);
          setIsDisabled(false);
        }
      }
    } catch (error) {
      console.error("Error occurred while submitting form:", error);
    }
  };

  const handleClosePaymentModal = () => {
    setShowCreditCardModal(false);
    setLoader(false);
  };

  const handleCheckboxChange = (event) => {
    const { checked } = event.target;
    setIsCheckboxCheckedSign(checked);
    setIsSignedButtonDisabled(!checked || !name.trim());
  };

  const fetchUpsellsItem = async () => {
    try {
      setLoader(true);
      const formData = { id: listingSlug, booking_slug: bookingSlug };
      const listingCmsRes = await dispatch(onboardingActions.getListingCmsInfo(formData));
  
      if (listingCmsRes?.payload?.status === HttpStatus.HTTP_OK) {
        const items = listingCmsRes?.payload?.result?.items;
        if (items && items.length > 0) {
          setItemsList(items);
        } else {
          gotoHomePage();
        }
      }
    } catch (error) {
      console.error("Error fetching upsell items:", error);
    } finally {
      setLoader(false);
    }
  };

  const hideUpgradeYourStay = () => { // No items in upgrade your stay found then redirect to reservation
    gotoHomePage();
  }

  const validateForm = (phoneValue, emailValue) => {
    // phoneValue includes the dial code (e.g. "+54 9 (11) 55551234")
    // Strip everything except digits, then remove the leading dial code digits
    // by trimming the "+" prefix and re-checking against E.164: total 7-15 digits
    // phoneValue includes dial code (e.g. "+54 9 (11) 55551234")
    // E.164 total: dial code (1-3 digits) + subscriber (min 4) = min 8, max 15
    let phoneValid = false;

    try {
      const phoneNumber = parsePhoneNumberFromString(phoneValue);
      phoneValid = phoneNumber?.isValid() ?? false;
    } catch {
      phoneValid = false;
    }
    const emailValid =
        emailValue.trim() !== "" && /\S+@\S+\.\S+/.test(emailValue);
    const isBothAreValid = phoneValid && emailValid
    setIsFormValid(isBothAreValid);
  };
  
  const handlePhoneChange = (value, country) => {
    setPhone(value);
    setPhoneError("");
    validateForm(value, email);
  };

  const handleEmailChange = (event) => {
    const { value } = event.target;
    setEmail(value);
    setEmailError("");
    validateForm(phone, value);
  };


  const handle2faSubmit = async (event) => {
    setIsLoading(true)
    setIsFormValid(false)
    if (event?.preventDefault) {
      event.preventDefault();
    }
    const formData = {
        email: email,
        phone_number: phone,
        booking_slug: bookingSlug,
    };
    
    try {
        const result = await dispatch(checkInActions.emailVerification(formData));
        if (result?.payload?.status === HttpStatus.HTTP_OK) {
            setAuthCode(result?.payload?.result?.auth_code);
            setIsLoading(false);
            setIsFormValid(true);
            setotpModal(true);
            setTimer(startTime)
        } else {
            toast(result?.payload?.message);
            setIsFormValid(true);
            setIsLoading(false);
            // setTimeout(() => {
            //     window.location.reload();
            // }, 1000);
        }
    } catch (error) {
        setIsFormValid(true);
        setIsLoading(false);
        console.error('Error occurred while submitting form:', error);
    }
  };

  const handleResendOTP = async (event) => {
      event.preventDefault();
      // setIsFormValidOTP(false);
      // Implement your logic to resend OTP here
      const formData = {
          verification_code: "",
          is_resend: 1,
          auth_code: authCode,
          booking_slug: bookingSlug
      };
      try {
          const result = await dispatch(checkInActions.verifyOtp(formData));
          if (result?.payload?.status === HttpStatus.HTTP_OK) {
              setOtpInputs(["", "", "", "", "", ""]);
              setTimer(startTime)
          }
      } catch (error) {
          // setIsFormValidOTP(true);
          console.error('Error occurred while submitting form:', error);
      }
    };

  const handleOtpPaste = (e) => {
      e.preventDefault();
      const pastedData = e.clipboardData.getData("text");
      
      if (pastedData.length === otpInputs.length && /^\d+$/.test(pastedData)) {       // Only 6 digits opt to paste in form 
          const updatedOtpInputs = pastedData.split("");
          setOtpInputs(updatedOtpInputs);
          setIsFormValidOTP(true);
          setUserInputOtp(pastedData);

          inputRefs.current[otpInputs.length - 1].focus();    
      }
    };

  const closeOtpModel = () => {
      setotpModal(false);
      setOtpInputs(["", "", "", "", "", ""]);
  }

  const handleOtpInputChange = (index, value) => {
    // Check if the value is a single digit number
    if (/^\d$/.test(value) || value === '') {
        const updatedOtpInputs = [...otpInputs];
        updatedOtpInputs[index] = value;
        setOtpInputs(updatedOtpInputs);

        // Move focus to the previous input field if the value is deleted
        if (value === '' && index > 0) {
            inputRefs.current[index - 1].focus();
        } else {
            // Move focus to the next input field if available
            if (index < inputRefs.current.length - 1 && value.trim() !== '') {
                inputRefs.current[index + 1].focus();
            }
        }

        // Check if all OTP inputs are filled
        const allInputsFilled = updatedOtpInputs.every(
            (input) => input.trim() !== ""
        );
        setIsFormValidOTP(allInputsFilled);
        const userInputOtp = updatedOtpInputs.join('');
        setUserInputOtp(userInputOtp);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setIsFormValidOTP(false)
    const formData = {
        verification_code: userInputOtp,
        is_resend: 0,
        booking_slug: bookingSlug,
        auth_code: authCode,
        is_sms_enabled: checkboxSMSEarlyCheckin
    };
    try {
        const result = await dispatch(checkInActions.verifyOtp(formData));
        if (result?.payload?.status === HttpStatus.HTTP_OK) {
            setIsFormValidOTP(true);
            setotpModal(false);
            await handleSubmitagree();
        } else {
            toast(result?.payload?.message);
            setIsLoading(false);
            setIsFormValidOTP(true)
        }
    } catch (error) {
        setIsFormValidOTP(true)
        console.error('Error occurred while submitting form:', error);
    } finally {
        setIsLoading(false);
    }
  };

  const handleCloseAgreementModal = () => {
    setPhone(""); // reset phone number
    setEmail(""); // reset email
    setName(""); // reset name
    setIsCheckboxCheckedSign(false);
    setCheckboxSMSEarlyCheckin(false);
    setShowAgreementModalboxagree(false); // close the popup
  }

  // Function to scroll to the top of the page
  const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
  };

  const handleSignedPopUp = (event) => {
    event.preventDefault();
    if(isAdditionalFormRequired && !isAdditionalFormCompleted) {
      setIsModalOpen(true);
    } else {
      if(isOtpVerified){ // If otp already verified then directly follow signdotted scenrio otherwise ask for otp verification.
        handleSubmitagree(event); 
      } else {
        handle2faSubmit(event); // send email and sms to user
      }
    }
  }

  /* Veriff Functions - START */
  const stopSse = () => {
    if (eventSourceRef.current) {
      eventSourceRef.current.close();
      eventSourceRef.current = null;
    }
    clearTimeout(reconnectTimerRef.current);
    reconnectTimerRef.current = null;
  };

  const closeVeriffModal = () => {
    // close the iframe previously it open (Fresh iframe load)
    veriffRef.current?.close();
    setSessionUrl("");
  };

  // Reset session data when verification is finished or canceled
  const resetSession = (isFormFinished = false) => {
    setIsDisabled(isFormFinished); // If form submitted then it should be true at end of next step it will remark as false.
    idVerificationStartedRef.current = false;
    setIdVerificationStarted(false);
    closeVeriffModal();
    stopSse();
  };

  const handleVerificationGuestID = async () => {
    if(isGuestBlocked || !isVeriffVerificationEnable) return ; // If Guest Blocked then prevent for create veriff session
    try {
      setIsDisabled(true); // Loading button status
      const formData = {
        booking_slug: bookingSlug,
      };
      const sessionApiResponse = await dispatch(
        checkInActions.createVeriffSeason(formData),
      );
      const { status, result, message } = sessionApiResponse?.payload || {};
      if (status === HttpStatus.HTTP_OK) {
        // Session created succesfully
        const sessionURL = result?.url ?? null;
        setSessionUrl(sessionURL);
      } else {
        // If blocked / already completed guest retry - rare case
        toast(message)
        setIsDisabled(false); // Loading button status
      }
    } catch (error) {
      console.error("error while creating the session:", error);
      resetSession();
    }
  };

  const hardRefreshAfterVeriffTimeout = () => {
    // Force a full reload to rebuild state from server after webhook timout.
    window.location.reload();
  };

  // Now after that veriff verification disable
  const handleVeriffFinished = () => {
    // Move to next step
    const formData = {
      is_house_rules_accepted: 0,
      is_signed_on_dotted_line: 0,
      is_verification_ids_uploaded: 1,
      is_deposit_option: 0,
      verification_images: null,
      is_arrival_info_accepted: 0,
      form_submission_at: 0
    };
    submitOnboardingSteps(formData);
  }
  /* Veriff Functions - END */

  // handle Veriff and Guest ID button flow
  const GuestIDUploadButton = (
     <div className="d-flex justify-content-center">
      <Button
        className="fillbutton"
        // Disable when loading or when guest is blocked due to offender match
        disabled={isDisabled || isGuestBlocked} 
        onClick={handleIdCardModalOpen}
      >
        {isDisabled ? <SpinnerLoader /> : verifybuttonText}
      </Button>
    </div>
  );

  const PhotoBlurryText = (
    <span
      className="sub-title-2 mt-3 mb-3"
      dangerouslySetInnerHTML={{
        __html: cmsContent?.photo_blury,
      }}
    />
  );

  /* JotForm Events */
  useEffect(() => {
    if (!isAdditionalFormRequired) return;
    const messageListener = async (event) => {
      if (event.origin !== 'https://form.jotform.com' && event.origin !== 'https://submit.jotform.com') return;
      const data = event.data;
      // If JotForm submits the form, we set the form as completed
      if (data.action == 'submission-completed') {
        setIsAdditionalFormCompleted(true);
        setIsModalOpen(false);
        const formData = {
          is_house_rules_accepted: 0,
          is_signed_on_dotted_line: 0,
          is_verification_ids_uploaded: 0,
          is_deposit_option: 0,
          is_arrival_info_accepted: 0,
          form_submission_at: 1
        };
        submitOnboardingSteps(formData);
        handle2faSubmit();
      } // Update the state to indicate the form is completed
      if(data.action == 'submission-error') {
        try {
          const formData = {
            booking_slug: bookingSlug,
            event: data
          };
          const result = await dispatch(checkInActions.checkFormStatus(formData));
          if (result?.payload?.status === HttpStatus.HTTP_OK) {
            setIsAdditionalFormCompleted(false);
          }
        } catch (error) {
          console.error('Error occurred while submitting form:', error);
        } finally {
          setIsLoading(false);
        }
      }
    };
    // Attach the event listener when the component mounts
    window.addEventListener('message', messageListener);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('message', messageListener);
    };
  }, [email, phone, isAdditionalFormRequired]);

  return (
    <section className="checkinginpage">
      <h3 id="checkingIn">Checking In</h3>
      <div className="card-section">
        <div className="accrodianBlock">
          {/* <Accordion activeKey={activeAccordionKey} flush> */}
          <Accordion activeKey={activeAccordionKey} flush>
            <Accordion.Item
              eventKey={!isFormSubmittedhouserules ? "0" : "fixedKey"} // Use a fixed key when isFormSubmittedhouserules is true
              disabled={isFormSubmittedhouserules}
              className={`cardYellow ${
                isFormSubmittedhouserules
                  ? "accrodionCollapsed"
                  : "accrodionCollapse"
              }`}
            >
              <Accordion.Header>
                {isFormSubmittedhouserules && <img src={checkIcon} />}{" "}
                <h2
                  style={
                    isFormSubmittedhouserules
                      ? { textDecoration: "line-through" }
                      : {}
                  }
                >
                  {" "}
                  {isFormSubmittedhouserules ? (
                    " "
                  ) : (
                    <img src={uncheckIcon} />
                  )}{" "}
                  <span>Read the House Rules</span>
                </h2>
              </Accordion.Header>
              <Accordion.Body>
                <hr className="mt-0 mb-3" />
                <h5>Please agree to all before continuing</h5>
                <Form onSubmit={handleSubmithouserules} className="mt-1">
                  <div className="swiperSliderone houseRulesSwiperLink">
                    <Swiper
                      id="rulesswiper"
                      onSwiper={(swiper) => setSwiperRef(swiper)} // Set swiperRef when Swiper is initialized
                      spaceBetween={10}
                      slidesPerView={1.5}
                      pagination={{ type: "fraction" }}
                      navigation={false}
                      modules={[Pagination, Navigation]}
                      className="mySwiper"
                      // onSlideChange={handleSlideChange} // Handle slide change event
                      onSlideNext={handleSlideNext} // Handle slide next event
                      onSlidePrev={handleSlidePrev} // Handle slide prev event
                      allowSlidePrev={isCheckboxChecked}
                      allowSlideNext={true} // Enable sliding to the next slide only if a checkbox is checked
                      allowTouchMove={isCheckboxChecked} // Allow touch interactions only if a checkbox is checked
                    >
                      {checkboxes.map((checkbox) => (
                        <SwiperSlide
                          key={checkbox.id}
                          style={{ width: "250px" }}
                          onClick={() => {
                            handleAgreeButtonClick();
                          }}
                        >
                          <div>
                            {/* <Form.Group className="mb-3" controlId={key}> */}
                            <Form.Check
                              type="checkbox"
                              id={checkbox.id}
                              checked={selectedCheckboxes.includes(checkbox.id)}
                              className="checkbox-fixed-height"
                              // label={checkbox.label}
                              label={commonRenderTextWithLinks(checkbox.label, false)}
                              disabled
                              onChange={() => {
                                const isChecked = selectedCheckboxes.includes(
                                  checkbox.id
                                );
                                if (isChecked) {
                                  // If checkbox is already checked, remove it from the selectedCheckboxes array
                                  setSelectedCheckboxes(
                                    selectedCheckboxes.filter(
                                      (id) => id !== checkbox.id
                                    )
                                  );
                                } else {
                                  // If checkbox is unchecked, add it to the selectedCheckboxes array
                                  setSelectedCheckboxes([
                                    ...selectedCheckboxes,
                                    checkbox.id,
                                  ]);
                                }
                              }}
                            />
                            {/* </Form.Group> */}
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                  <hr className="mt-3 mb-4" />
                  <div className="d-flex justify-content-center">
                    <Button
                      className="fillbutton"
                      type="submit"
                      disabled={isButtonDisabled}
                      onClick={handleAgreeButtonClick}
                    >
                      {buttonText}
                    </Button>
                  </div>
                </Form>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              eventKey={!isFormSubmittedagree ? "1" : "fixedKey"} // Use a fixed key when isFormSubmittedagree is true
              disabled={isFormSubmittedagree}
              className={`cardOrange ${
                isFormSubmittedagree
                  ? "accrodionCollapsed"
                  : "accrodionCollapse"
              }`}
            >
              <Accordion.Header>
                {isFormSubmittedagree && <img src={checkIcon} />}{" "}
                <h2
                  style={
                    isFormSubmittedagree
                      ? { textDecoration: "line-through" }
                      : {}
                  }
                >
                  {" "}
                  {isFormSubmittedagree ? " " : <img src={uncheckIcon} />}{" "}
                  <span>Sign on the dotted line</span>
                </h2>
              </Accordion.Header>
              <Accordion.Body>
                <hr className="mt-0 mb-3" />
                <Form className="mt-1">
                  <div className="readagreement">
                    <span
                      dangerouslySetInnerHTML={{
                        __html: listingCms?.rental_instructions,
                      }}
                    />
                    {/* <p className="text-upppercase"> RENTAL AGREEMENT </p>
                    <p className="text-upppercase">
                      {" "}
                      1: RESERVATION INFORMATION{" "}
                    </p>
                    <p className="text-upppercase"> CHECK-IN </p>
                    <p>
                      The check-in time is after 3:00 p.m. on the first day of
                      your reservation. Sometimes early check-in is available
                      and is easy to purchase on your Happy Guest reservation
                      page.
                    </p>
                    <p className="text-upppercase"> CHECK-OUT </p>
                    <p>
                      The check-out time is before 11:00 a.m. on the last day of
                      your reservation. Sometimes late check-out is available
                      and is easy to purchase on your Happy Guest reservation
                      page. Late fees will be charged for departures after 11:00
                      a.m. that did not purchase a late check-out.
                    </p> */}
                  </div>
                  <div className="d-flex justify-content-center">
                    <Button
                      className="fillbutton"
                      onClick={handleAgreementModalOpen}
                    >
                      I have read the agreement
                    </Button>
                  </div>
                </Form>
              </Accordion.Body>
            </Accordion.Item>

            {reservationType === 0 && (
              <Accordion.Item
                eventKey={!isFormSubmittedverify ? "2" : "fixedKey"} // Use a fixed key when isFormSubmittedverify is true
                disabled={isFormSubmittedverify}
                className={`cardBlue ${
                  isFormSubmittedverify
                    ? "accrodionCollapsed"
                    : "accrodionCollapse"
                }`}
              >
                <Accordion.Header>
                  {isFormSubmittedverify && <img src={checkIcon} />}{" "}
                  <h2
                    style={
                      isFormSubmittedverify
                        ? { textDecoration: "line-through" }
                        : {}
                    }
                  >
                    {" "}
                    {isFormSubmittedverify ? (
                      " "
                    ) : (
                      <img src={uncheckIcon} />
                    )}{" "}
                    <span>Verify it's you</span>
                  </h2>
                </Accordion.Header>
                <Accordion.Body>
                  <hr className="mt-0 mb-3" />
                  <h5>Please add photos of your ID</h5>
                  <span className="sub-title mb-2">
                    Can be a Passport or Driver's License
                  </span>
                  <Form className="mt-1" onSubmit={handleSubmitverify}>
                    <div className="swiperSliderone">
                      <Swiper
                        id="photoswiper"
                        onSwiper={(swiper) => setVerifySwiperRef(swiper)} // Set swiperRef when Swiper is initialized
                        spaceBetween={10}
                        slidesPerView={1.5} // Set slidesPerView to 1.5
                        onSlideChange={handleVerifySlideChange}
                        allowSlidePrev={
                          selectedFrontImage &&
                          selectedBackImage &&
                          selectedSelfieImage
                            ? true
                            : false
                        } // Allow sliding to previous slide if any image is uploaded
                        allowSlideNext={true} // Enable sliding to the next slide only if all images are uploaded
                        allowTouchMove={
                          selectedFrontImage &&
                          selectedBackImage &&
                          selectedSelfieImage
                            ? true
                            : false
                        } // Allow touch interactions only if all images are uploaded
                        pagination={{
                          type: "fraction",
                        }}
                        navigation={false}
                        modules={[Pagination, Navigation]}
                        className="mySwiper"
                      >
                        <SwiperSlide>
                          <div
                            className="id_card_block"
                            onClick={handleIdCardModalOpen}
                          >
                            {selectedFrontImage ? (
                              <div className="id_card_uploaded">
                                <figure>
                                  <img src={selectedFrontImage} alt="Preview" />
                                  <span
                                    className="deletePreview"
                                    onClick={handleDeleteFrontImage}
                                  >
                                    <img src={deleteImage} />
                                  </span>
                                </figure>
                              </div>
                              ) : (
                                <div className="id_card_uploaded">
                                  <div>
                                    <img src={Frontid} alt="Preview" />
                                    <p className="id_label">
                                      Front of <span>ID</span>
                                    </p>
                                  </div>
                                </div>
                                )}
                          </div>
                        </SwiperSlide>
                        <SwiperSlide>
                          <div
                            className="id_card_block"
                            onClick={handleIdCardModalOpen}
                          >
                            {selectedBackImage ? (
                              <div className="id_card_uploaded">
                                <figure>
                                  <img src={selectedBackImage} alt="Preview" />
                                  <span
                                    className="deletePreview"
                                    onClick={handleDeleteBackImage}
                                  >
                                    <img src={deleteImage} />
                                  </span>
                                </figure>
                              </div>
                              ) : (
                                <div className="id_card">
                                  <div>
                                    <img src={Backid} alt="Preview" />
                                    <p className="id_label">
                                      Back of <span>ID</span>
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </SwiperSlide>
                          <SwiperSlide>
                            <div
                              className="id_card_block"
                              onClick={handleIdCardModalOpen}
                            >
                              {selectedSelfieImage ? (
                                <div className="id_card_uploaded_selfie">
                                  <figure>
                                    <img
                                      src={selectedSelfieImage}
                                      alt="Preview"
                                    />
                                    <span
                                      className="deletePreview"
                                      onClick={handleDeleteSelfieImage}
                                    >
                                      <img src={deleteImage} />
                                    </span>
                                  </figure>
                                </div>
                              ) : (
                                <div className="id_card_selfie">
                                  <div>
                                    <img src={Selfieid} alt="Preview" />
                                    <p className="id_label">
                                      Selfie with <span>ID</span>
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </SwiperSlide>
                        </Swiper>
                      </div>
                      {/* Start Verification Button if Veriff Enable */}
                      {isVeriffVerificationEnable && GuestIDUploadButton}
                      {PhotoBlurryText}
                      {/* Regular Flow Button */}
                      {!isVeriffVerificationEnable && GuestIDUploadButton}
                  </Form>
                </Accordion.Body>
              </Accordion.Item>
            )}

            {reservationType === 0 && isGuestAllowedToPay && (
              <Accordion.Item eventKey="3" className="cardGreen">
                <Accordion.Header>
                  {isFormSubmittedProtection && <img src={checkIcon} />}{" "}
                  <h2
                    style={
                      isFormSubmittedProtection
                        ? { textDecoration: "line-through" }
                        : {}
                    }
                  >
                    {" "}
                    {isFormSubmittedProtection ? (
                      " "
                    ) : (
                      <img src={uncheckIcon} />
                    )}{" "}
                    <span>Swipe for Incidentals</span>
                  </h2>
                </Accordion.Header>
                <Accordion.Body>
                  <Form className="mt-0">
                    <hr className="mt-0 mb-2" />
                    <div className="radiobox">
                      {!isHoldOnlyWaiver && (
                        <Form.Group className="mb-1" controlId="nonrefundable">
                          <Form.Check
                            type="radio"
                            // label={securityDepositAlert?.non_refundable_title}
                            label={
                              <span
                                className="swipe-html-text"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    securityDepositAlert?.non_refundable_title,
                                }}
                              />
                            }
                            name="paymentOption"
                            value="nonrefundable"
                            // defaultChecked // Add defaultChecked here
                            checked={selectedPaymentOption === "nonrefundable"}
                            onChange={handlePaymentOptionChange}
                          />
                        </Form.Group>
                      )}
                      <Form.Group className="mb-2" controlId="refundable">
                        {!isHoldOnlyWaiver ? (
                        <Form.Check
                          type="radio"
                          // label={securityDepositAlert?.refundable_title}
                          label={
                            <span
                              className="swipe-html-text"
                              dangerouslySetInnerHTML={{
                                __html: securityDepositAlert?.refundable_title,
                              }}
                            />
                          }
                          name="paymentOption"
                          value="refundable"
                          checked={selectedPaymentOption === "refundable"}
                          onChange={handlePaymentOptionChange}
                        />
                        ) : (
                        <label class="form-check-label">
                        <span
                          className="swipe-html-text"
                          dangerouslySetInnerHTML={{ __html: securityDepositAlert?.refundable_title }}
                        />
                        </label>
                        )}
                      </Form.Group>
                    </div>
                    <hr className="mt-0 mb-3" />
                    {/* Display HOLD_ONLY or incidental description based on waiver option */}
                    <span
                      dangerouslySetInnerHTML={{
                        __html: isHoldOnlyWaiver
                        ? cmsContent?.hold_only_description
                        : cmsContent?.incidental_description,
                      }}
                    />
                    <div className="d-flex justify-content-center">
                      <Button
                        className="fillbutton"
                        onClick={handleCreditCardModalOpen}
                        disabled={loader ? true : false}
                      >
                        {loader ? (
                          <>
                            <SpinnerLoader />
                          </>
                        ) : (
                          "Add card"
                        )}
                      </Button>
                    </div>
                  </Form>
                </Accordion.Body>
              </Accordion.Item>
            )}

            {reservationType === 1 && isGuestAllowedToPay && (
              <Accordion.Item eventKey="3" className="cardGreen customCardBlue">
                <Accordion.Header>
                  {isFormSubmittedProtection && <img src={checkIcon} />}{" "}
                  <h2
                    style={
                      isFormSubmittedProtection
                        ? { textDecoration: "line-through" }
                        : {}
                    }
                  >
                    {" "}
                    {isFormSubmittedProtection ? (
                      " "
                    ) : (
                      <img src={uncheckIcon} />
                    )}{" "}
                    <span>Review protection options</span>
                  </h2>
                </Accordion.Header>
                <Accordion.Body>
                  <Form className="mt-0">
                    <hr className="mt-0 mb-2" />
                    <div className="radiobox">
                      <p>Accidental Damage Protection (recommended)</p>
                      <Form.Group className="mb-1" controlId="nonrefundable">
                        <Form.Check
                          type="radio"
                          label={
                            <span
                              className="swipe-html-text"
                              dangerouslySetInnerHTML={{
                                __html:
                                  securityDepositAlert?.non_refundable_title,
                              }}
                            />
                          }
                          name="paymentOption"
                          value="nonrefundable"
                          checked={selectedPaymentOption === "nonrefundable"}
                          onChange={handlePaymentOptionChange}
                        />
                      </Form.Group>
                      <Form.Group className="mb-2" controlId="refundable">
                        <Form.Check
                          type="radio"
                          label={
                            <span
                              className="swipe-html-text"
                              dangerouslySetInnerHTML={{
                                __html: securityDepositAlert?.refundable_title,
                              }}
                            />
                          }
                          name="paymentOption"
                          value="refundable"
                          checked={selectedPaymentOption === "refundable"}
                          onChange={handlePaymentOptionChange}
                        />
                      </Form.Group>
                    </div>
                    <hr className="mt-0 mb-3" />

                    <span className="review-protection-description"
                      dangerouslySetInnerHTML={{
                        __html: cmsContent?.review_protection_description,
                      }}
                    />
                    <div className="d-flex justify-content-center">
                      <Button
                        className="fillbutton"
                        onClick={handleCreditCardModalOpen}
                        disabled={loader ? true : false}
                      >
                        {loader ? (
                          <>
                            <SpinnerLoader />
                          </>
                        ) : (
                          reservationType === 1 && selectedPaymentOption === "refundable" ? "I’m all set" :"Add card"
                        )}
                      </Button>
                    </div>
                  </Form>
                </Accordion.Body>
              </Accordion.Item>
            )}

            <Accordion.Item eventKey="4" className="cardGreen customcardPink">
              <Accordion.Header>
                <h2>
                  <img src={uncheckIcon} /> <span>Upgrade your stay</span>
                </h2>
              </Accordion.Header>
              <Accordion.Body>
                <section className="reservationnpage">
                  <div className="card-section specific-bg">
                    <div className="cardGreen2 cardPink checkedIn-cardPink">
                      <UpgradeItems 
                       itemsList={itemsList}
                       needToEmailName={false} // in checkin-form name and email already taken
                       cmsContent={cmsContent}
                       hideUpgradeYourStay={hideUpgradeYourStay}
                      />
                    </div>
                  </div>
                </section>
                <div className="d-flex justify-content-center">
                  <Button
                    className="fillbutton"
                    onClick={() => gotoHomePage()}
                    disabled={loader ? true : false}
                  >
                    {loader ? (
                      <>
                        <SpinnerLoader />
                      </>
                    ) : (
                      "Take me to my arrival info"
                    )}
                  </Button>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          </div>
          </div>

      {/* i have read the agreement */}
      <Modal
        show={showAgreementModalagree}
        onHide={() => handleCloseAgreementModal()}
        dialogClassName="modal-90w modal-bottom"
        aria-labelledby="example-custom-modal-styling-title"
        className={`agreement ${
          isFormSubmittedagree ? "agreement-d-none" : "agreement-d-block"
        }`}
        backdrop="static"
      >
        <Modal.Header
          closeButton
          onClick={() => handleCloseAgreementModal()}
        ></Modal.Header>
        <Modal.Body>
          <Form autoComplete="off" onSubmit={handleSignedPopUp}>
            {/* <h2>Please sign the rental agreement</h2> */}
            <h2>Signed</h2>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Control
                type="text"
                placeholder="Your name"
                value={name}
                onChange={handleNameChange}
                required
                disabled={isLoading} // disable field while api process
                autoComplete="off"
              />
            </Form.Group>
            {
              isOtpVerified === false && (
                <>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlInput3"
                  >
                    {/* <Form.Label>Email</Form.Label> */}
                    <Form.Control
                        type="email"
                        className="input-text2"
                        placeholder="Please enter email for verification"
                        value={email}
                        onChange={handleEmailChange}
                        required
                        disabled={isLoading} // disable field while api process
                        autoComplete="off"
                    />
                    <Form.Text className="text-danger">{emailError}</Form.Text>
                  </Form.Group>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlInput2"
                  >
                    {/* <Form.Label>Mobile</Form.Label> */}
                    <PhoneInput
                        country={"us"} // default country
                        value={phone}
                        className="input-text2"
                        onChange={handlePhoneChange}
                        countries={customCountries}
                      inputProps={{
                        required: true,
                        type: "text",        // force text instead of tel
                        autoComplete: "off", // or 'new-password'
                        autoCorrect: "off",
                        autoCapitalize: "off",
                        spellCheck: false,
                        inputMode: "tel"     // still shows numeric keyboard
                      }}
                        placeholder="1 (702) 123-4567"
                        disabled={isLoading} // disable field while api process
                    />
                    <Form.Text className="text-danger">{phoneError}</Form.Text>
                  </Form.Group>
                  <Form.Group className="mb-3 smsCheckbox" controlId="agreementCheckbox">
                  <div className="d-flex align-items-start">
                      <label class="custom-checkbox">
                      <input
                          type="checkbox"
                          onClick={() => setCheckboxSMSEarlyCheckin(prev => !prev)}
                          disabled={isLoading} // disable field while api process
                      />
                      <span class="checkmark"></span>
                      </label>
                      <div className="checkBox-text">
                      <span
                          className="checkBox-text-heading"
                          dangerouslySetInnerHTML={{
                            __html: `${chargeOtpText ? chargeOtpText: ""}`,
                          }}
                      ></span>
                      </div>
                  </div>
                  </Form.Group>
                </>
              )
            }
            <Form.Group className="mb-3" controlId="agreementCheckbox">
              <div className="d-flex align-items-start">
                <label class="custom-checkbox">
                  <input
                    type="checkbox"
                    checked={isCheckboxCheckedSign}
                    onChange={(e) => handleCheckboxChange(e)}
                    disabled={isLoading} // disable field while api process
                  />
                  <span class="checkmark"></span>
                </label>
               {cmsContent?.signing_agreement_text &&  <div className="checkBox-text">
                  <span
                    className="checkBox-text-heading"
                    dangerouslySetInnerHTML={{
                      __html: `${cmsContent?.signing_agreement_text} <a href="javascript:void(0)" class="checkBox-text-heading-link" >here</a>`,
                    }}
                  ></span>
                </div>
                }
              </div>
            </Form.Group>
            <div className="d-flex justify-content-between">
              <Button
                className="outlinebutton"
                onClick={() => handleCloseAgreementModal()}
              >
                Cancel
              </Button>
              <Button
                className="fillbutton"
                type="submit"
                disabled={isSignedButtonDisabled || isLoading || !isFormValid}  // Disable the button if the checkbox is not checked or the form is submitting
                onClick={handleClick}
              > 
              {isLoading ? <SpinnerLoader /> : "Signed!"}   
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      {/* End i have read the agreement */}

      {/* Modal for Consumer Consent Disclosure */}
      <Modal
        className="consumer-content-modal"
        show={showConsentModal}
        onHide={() => setShowConsentModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Consumer Consent Disclosure</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span
            className="sub-title-2 mt-3 mb-3"
            dangerouslySetInnerHTML={{
              __html: cmsContent?.consumer_content_discloser,
            }}
          ></span>
        </Modal.Body>
      </Modal>
      {/* Add Credit Card & Pay */}
      <Modal
        show={showCreditCardModal}
        onHide={() => handleClosePaymentModal()}
        dialogClassName="modal-90w modal-bottom"
        aria-labelledby="example-custom-modal-styling-title"
        className="addcreditcard payment-popup"
        backdrop="static"
      >
        <Modal.Header
          closeButton
          onClick={() => handleClosePaymentModal()}
        ></Modal.Header>
        <Modal.Body>
          <Elements stripe={stripePromise} options={options}>
            <CheckoutForm
              closeCheckoutModal={closeCheckoutModal}
              // gotoHomePage={gotoHomePage}
              nextUpsellCardStep={nextUpsellCardStep}
              bookingSlug={bookingSlug}
              clientSecret={clientSecret}
              customerId={customerId}
              stripeId={stripeId}
              paymentSlug={paymentSlug}
              intentType={intentType}
              cmsContent={cmsContent}
              securityDepositAlert={securityDepositAlert}
            />
          </Elements>
        </Modal.Body>
      </Modal>
      {/* End i have read the agreement */}

      {/* Upload id card */}
      <Modal
        show={showIdCardModal_Front}
        // onHide={() => setshowFrontIdCardModal(false)}
        onChange={() => setshowIdCardModal_Front(false)}
        dialogClassName="modal-90w modal-bottom"
        aria-labelledby="example-custom-modal-styling-title"
        className="idcard"
      >
        <Modal.Header
          closeButton
          onClick={() => setshowIdCardModal_Front(false)}
        ></Modal.Header>
        <Modal.Body className="pb-4">
          <Form onSubmit={handleSubmitverify}>
            <h2 className="mb-3">How do you want to upload? </h2>
            {/* <hr/> */}

            <div className="d-flex flex-column justify-content-between gap-2">
              <div className="id_screen_upd">
                <Button
                  className="outlinebutton w-100"
                  onClick={handleFrontButtonClick}
                >
                  Take Photo
                </Button>
                <input
                  type="file"
                  name="front_image"
                  accept="image/png, image/jpg, image/jpeg,image/heic"
                  id="selfie_id"
                  capture="camera"
                  className="input_file_upload"
                  onChange={handleFrontImageChange} // Add onChange event handler
                />
              </div>

              <div className="id_screen_upd">
                <Button
                  className="outlinebutton w-100 btn"
                  onClick={handleFrontButtonClick}
                >
                  Select from photo library
                </Button>
                <input
                  type="file"
                  name="front_image"
                  accept="image/png, image/jpg, image/jpeg,image/heic"
                  id="front_id_card"
                  className="input_file_upload"
                  onChange={handleFrontImageChange} // Add onChange event handler
                />
              </div>

              {/* <div className="id_screen_upd">
                <Button className="outlinebutton w-100 btn">Take photo</Button>
                <input
                  type="file"
                  name="front_image"
                  accept="image/png, image/jpg, image/jpeg,image/heic"
                  id="selfie_id"
                  capture="camera"
                  onChange={handleSelfieImageChange} 
                />
              </div> */}
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        show={showIdCardModal_Back}
        onChange={() => setshowIdCardModal_Back(false)}
        dialogClassName="modal-90w modal-bottom"
        aria-labelledby="example-custom-modal-styling-title"
        className="idcard"
      >
        <Modal.Header
          closeButton
          onClick={() => setshowIdCardModal_Back(false)}
        ></Modal.Header>
        <Modal.Body className="pb-4">
          <Form onSubmit={handleSubmitverify}>
            <h2 className="mb-3">How do you want to upload? </h2>
            {/* <hr/> */}

            <div className="d-flex flex-column justify-content-between gap-2">
              <div className="id_screen_upd">
                <Button
                  className="outlinebutton w-100"
                  onClick={handleBackButtonClick}
                >
                  Take Photo
                </Button>
                <input
                  type="file"
                  name="front_image"
                  accept="image/png, image/jpg, image/jpeg,image/heic"
                  id="selfie_id"
                  capture="camera"
                  className="input_file_upload"
                  onChange={handleBackImageChange} // Add onChange event handler
                />
              </div>
              <div className="id_screen_upd">
                <Button
                  className="outlinebutton w-100 btn"
                  onClick={handleBackButtonClick}
                >
                  Select from photo library
                </Button>
                <input
                  type="file"
                  name="front_image"
                  accept="image/png, image/jpg, image/jpeg,image/heic"
                  id="back_id_card"
                  className="input_file_upload"
                  onChange={handleBackImageChange} // Add onChange event handler
                />
              </div>

              {/* <div className="id_screen_upd">
                <Button className="outlinebutton w-100 btn">Take photo</Button>
                <input
                  type="file"
                  name="front_image"
                  accept="image/png, image/jpg, image/jpeg,image/heic"
                  id="selfie_id"
                  capture="camera"
                  onChange={handleSelfieImageChange} 
                />
              </div> */}
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        show={showIdCardModal_Selfie}
        onChange={() => setshowIdCardModal_Selfie(false)}
        dialogClassName="modal-90w modal-bottom"
        aria-labelledby="example-custom-modal-styling-title"
        className="idcard"
      >
        <Modal.Header
          closeButton
          onClick={() => setshowIdCardModal_Selfie(false)}
        ></Modal.Header>
        <Modal.Body className="pb-4">
          <Form onSubmit={handleSubmitverify}>
            <h2 className="mb-3">How do you want to upload? </h2>
            {/* <hr/> */}

            <div className="d-flex flex-column justify-content-between gap-2">
              <div className="id_screen_upd">
                <Button
                  className="outlinebutton w-100 btn"
                  onClick={handleSelfieButtonClick}
                >
                  Take photo
                </Button>
                <input
                  type="file"
                  name="front_image"
                  accept="image/png, image/jpg, image/jpeg,image/heic"
                  id="selfie_id"
                  capture="camera"
                  className="input_file_upload"
                  onChange={handleSelfieImageChange} // Add onChange event handler
                />
              </div>
              <div className="id_screen_upd">
                <Button
                  className="outlinebutton w-100 btn"
                  onClick={() => handleSelfieButtonClick(false)}
                >
                  Select from photo library
                </Button>
                <input
                  type="file"
                  name="front_image"
                  accept="image/png, image/jpg, image/jpeg,image/heic"
                  id="selfie_id_card"
                  className="input_file_upload"
                  onChange={handleSelfieImageChange} // Add onChange event handler
                />
              </div>

              {/* <div className="id_screen_upd">
                <Button className="outlinebutton w-100 btn">Take photo</Button>
                <input
                  type="file"
                  name="front_image"
                  accept="image/png, image/jpg, image/jpeg,image/heic"
                  id="selfie_id"
                  capture="camera"
                  onChange={handleSelfieImageChange} 
                />
              </div> */}
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      {/* End Upload id card */}

      {/* OTP Modalbox */}
      <Modal
          show={showotpModal}
          onHide={closeOtpModel}
          dialogClassName="modal-90w modal-bottom"
          aria-labelledby="example-custom-modal-styling-title"
          className="otp-modal"
          backdrop="static"
          // maskClosable={false}
      >
          <Modal.Header
              closeButton
              onClick={closeOtpModel}
          ></Modal.Header>
          <Modal.Body>
              <Form onSubmit={handleSubmit}>
                  <h2 className="mb-2">Verification</h2>
                  <h6 className="mb-2 pb-2" dangerouslySetInnerHTML={{
                      __html: `${cmsContent?.otp_description}`,
                  }}></h6>
                  <Form.Group className="mb-4" controlId="otpnumber">
                      <div className="d-flex justify-content-center gap-2">
                          {otpInputs.map((input, index) => (
                              <Form.Control
                                  key={index}
                                  type="tel" // Use type="text" to prevent number type validation
                                  className="input-text-otp"
                                  value={input}
                                  onChange={(e) => handleOtpInputChange(index, e.target.value)}
                                  maxLength={1} // Limit input length to 1 character
                                  ref={(ref) => inputRefs.current[index] = ref} // Ref for the input field
                                  required
                                  onPaste={index === 0 ? handleOtpPaste : null} 
                              />
                          ))}
                      </div>
                      {/* <Form.Text className="text-danger">{otpError}</Form.Text> */}
                  </Form.Group>

                  <div className="d-flex justify-content-center">
                      <Button
                          className="fillbutton"
                          type="submit"
                          disabled={!isFormValidOTP}
                      >

                          {isLoading ? (<><SpinnerLoader /></>) : ("Verify")}
                      </Button>
                  </div>
                  <div className="d-flex justify-content-center mt-3">
                      <p>
                          {timer === 0 ?
                              <Link to="#" className="text-overline2" onClick={handleResendOTP}>
                                  Resend Code
                              </Link>
                              : `Resend code in ${timer} seconds`
                          }
                      </p>
                  </div>
              </Form>
          </Modal.Body>
      </Modal>
      {/* OTP Modalbox */}
      {/* sessionURL should have and guest must be not blocked */}
      {sessionUrl && !isGuestBlocked && (
        <div className="veriff-modal-backdrop" role="dialog" aria-modal="true">
          <div className="veriff-modal">
            <div
              id={embeddedContainerId}
              className="veriff-embedded-container veriff-embedded-container--modal"
            />
          </div>
        </div>
      )}

      {/* New Verification form  */}
      <Modal
        show={isModalOpen}
        onHide={() => setIsModalOpen(false)}
        dialogClassName="modal-90w modal-bottom"
          aria-labelledby="example-custom-modal-styling-title "
          className="user_form agreement-d-block"
      >
        <Modal.Body>
          <>
          <div className="h-89">
            <iframe
              ref={iframeRef}
              src={openForm}  // Ensure openForm contains the correct JotForm URL
              title="JotForm"
              width="100%"
              height="100%"
              frameBorder="0"
            ></iframe>
            </div>
          </>
        </Modal.Body>
      </Modal>
    </section>
  );
}
export default Checkingin;